import { createStore } from 'vuex';
import { authModule } from '@pulte/pulte-myloan-npm';

import { state } from './state';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
const store = createStore({
    state,
    getters,
    actions,
    mutations,
    modules: {
        authModule
    }
});

export default store;